import { USER_ROLES } from '@/utilities/constant';
import { getUser } from '@/utilities/setting';

export const EDIT_LOCK_MINUTES_BEFORE_START = 5;
const IST_OFFSET_MS = 330 * 60_000;

interface EditableCampaign {
  campaign_status?: number | string | null;
  start_date?: string | null;
  start_hours?: string | null;
}

export function scheduledStartMs(c: EditableCampaign): number | null {
  const d = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(c.start_date || ''));
  const t = /^(\d{1,2}):(\d{2})(?::(\d{2}))?/.exec(String(c.start_hours || ''));
  if (!d || !t) return null;
  return Date.UTC(Number(d[1]), Number(d[2]) - 1, Number(d[3]), Number(t[1]), Number(t[2]), Number(t[3] || 0)) - IST_OFFSET_MS;
}

export function isReadyEditLocked(c: EditableCampaign, nowMs: number = Date.now()): boolean {
  if (Number(c.campaign_status) !== 0) return false;
  const start = scheduledStartMs(c);
  return start != null && nowMs >= start - EDIT_LOCK_MINUTES_BEFORE_START * 60_000;
}

export function canEditCampaignNow(c: EditableCampaign, nowMs: number = Date.now()): boolean {
  const status = Number(c.campaign_status);
  if (status === 9) return true;
  return status === 0 && !isReadyEditLocked(c, nowMs);
}

export const READY_EDIT_LOCKED_MESSAGE = `Ready campaigns can only be edited up to ${EDIT_LOCK_MINUTES_BEFORE_START} minutes before their scheduled start time.`;

export function canChangeCampaignStatus(c: { user_id?: number | string | null }): boolean {
  const user = getUser();
  if (user?.role === USER_ROLES.SUPERADMIN || user?.role === USER_ROLES.SUB_SUPERADMIN) return true;
  return c.user_id != null && user?.id != null && Number(c.user_id) === Number(user.id);
}
